<div class="page-tickets-venue">

  <!-- Cabecera -->
  <div class="tickets-venue-header">
    <div>
      <p class="m-0 title-tab">Entradas base</p>
      <p class="m-0 subtitle-info">Plantilla de entradas para los eventos de este espacio.</p>
    </div>
    <div class="btn-create" *ngIf="allowCreate" (click)="openCreateTicket()">
      <i class="fal fa-plus-circle"></i>
      <span>Añadir entrada</span>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="!loaded" class="container-lottie">
    <div class="loading-container">
      <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
          containerClass="loading-box"></ng-lottie>
    </div>
  </div>

  <div *ngIf="loaded">

    <!-- Sin entradas -->
    <div *ngIf="tickets.length === 0" class="empty-state">
      <i class="fal fa-ticket-alt empty-icon"></i>
      <p>No hay entradas base creadas todavía.</p>
      <span>Crea entradas base para que aparezcan automáticamente al crear un evento en este espacio.</span>
    </div>

    <!-- Tabla -->
    <div *ngIf="tickets.length > 0" class="tickets-table" [class.has-map]="hasMap">

      <!-- Cabecera -->
      <div class="table-header">
        <span class="col-name">Entrada</span>
        <span class="col-price" *ngIf="!hasMap">Precio</span>
        <span class="col-toggle">Activo</span>
        <span class="col-toggle">Descuentos</span>
        <span class="col-toggle">Solo taquilla</span>
        <span class="col-delete"></span>
      </div>

      <!-- Fila por cada ticket -->
      <div class="ticket-row-wrapper" *ngFor="let ticket of tickets; let i = index"
           [class.expanded]="isExpanded(ticket.id)"
           [class.inactive]="ticket.active === false">

        <div class="ticket-row">

          <!-- Nombre editable -->
          <div class="col-name">
            <i class="fal fa-chevron-right chevron" *ngIf="hasMap && levels?.length > 0"
               [class.rotated]="isExpanded(ticket.id)"
               (click)="toggleExpand(ticket.id)"></i>
            <input class="ticket-name-input"
                   [value]="ticket.name"
                   (focus)="onNameFocus(ticket)"
                   (input)="markDirty('name_' + ticket.id); currentNameEdit[ticket.id] = $any($event.target).value"
                   (blur)="saveName(ticket, i, $event)"
                   (keydown.enter)="$any($event.target).blur()"
                   [disabled]="!allowCreate"
                   maxlength="50" />
            <div class="name-action-slot">
              <button *ngIf="isDirty('name_' + ticket.id)"
                      class="btn-save"
                      type="button"
                      (click)="saveRowFields(ticket, i)">
                <i class="fal fa-save"></i>
              </button>
              <i class="fal fa-check saved-check" *ngIf="isSaved('name_' + ticket.id)"></i>
            </div>
            <span class="ticket-badge special" *ngIf="ticket.special_seats">Especial</span>
          </div>

          <!-- Precio (sin mapa) -->
          <div class="col-price" *ngIf="!hasMap">
            <div class="price-wrap">
              <input type="number"
                     class="price-input"
                     [value]="ticket.price > 0 ? ticket.price : null"
                     (focus)="onPriceFocus(ticket)"
                     (input)="markDirty('price_' + ticket.id); currentPriceEdit[ticket.id] = $any($event.target).value"
                     (blur)="savePrice(ticket, i, $event)"
                     (keydown)="preventNegative($event)"
                     (keydown.enter)="$any($event.target).blur()"
                     [disabled]="!allowCreate"
                     min="0" step="0.01" placeholder="—" />
              <span class="price-sym">€</span>
            </div>
          </div>

          <!-- Toggle activo -->
          <div class="col-toggle">
            <mat-slide-toggle
              [checked]="ticket.active !== false"
              [disabled]="!allowCreate"
              (change)="allowCreate && toggleTicketActive(ticket, i, $event)"
              color="primary">
            </mat-slide-toggle>
          </div>

          <!-- Toggle descuentos -->
          <div class="col-toggle">
            <mat-slide-toggle
              class="toggle-pink"
              [checked]="ticket.allow_discounts === true"
              [disabled]="!allowCreate"
              (change)="allowCreate && toggleAllowDiscounts(ticket, i, $event)">
            </mat-slide-toggle>
          </div>

          <!-- Toggle solo taquilla -->
          <div class="col-toggle">
            <mat-slide-toggle
              [checked]="ticket.only_tpv_sales === true"
              [disabled]="!allowCreate"
              (change)="allowCreate && toggleOnlyTpvSales(ticket, i, $event)"
              color="primary">
            </mat-slide-toggle>
          </div>

          <!-- Acciones: guardar precio / check / eliminar -->
          <div class="col-delete" *ngIf="allowCreate">
            <button *ngIf="isDirty('price_' + ticket.id)"
                    class="btn-save"
                    type="button"
                    (click)="saveRowFields(ticket, i)">
              <i class="fal fa-save"></i>
            </button>
            <i class="fal fa-check saved-check" *ngIf="isSaved('price_' + ticket.id)"></i>
            <button class="btn-delete" (click)="deleteTicket(ticket, i)">
              <i class="fal fa-trash"></i>
            </button>
          </div>
        </div>

        <!-- Zonas expandidas (con mapa) -->
        <div class="ticket-levels" *ngIf="isExpanded(ticket.id) && hasMap && levels?.length > 0">

          <div class="levels-header">
            <span>Zona</span>
            <span></span>
            <span>Activo</span>
            <span>Precio</span>
            <span></span>
          </div>

          <div class="level-row" *ngFor="let level of levels"
               [class.level-disabled]="getTicketLevel(ticket, level.id).hidden">

            <!-- col 1: nombre de zona -->
            <div class="level-col-name">
              <div class="level-color-dot" [style.background]="level.color || 'var(--color-primary)'"></div>
              <span class="level-name">{{ level.name }}</span>
            </div>

            <!-- col 2: vacía -->
            <div></div>

            <!-- col 3: toggle activo -->
            <div class="level-col-toggle">
              <mat-slide-toggle
                [disabled]="!allowCreate || getTicketLevel(ticket, level.id).hidden || getTicketLevel(ticket, level.id).price == null"
                [checked]="ticket.active && getTicketLevel(ticket, level.id)?.active !== false"
                (change)="allowCreate && toggleTicketLevelActive(ticket, level.id, $event)"
                (click)="$event.stopPropagation()"
                color="primary">
              </mat-slide-toggle>
            </div>

            <!-- col 4: precio -->
            <div class="level-col-price">
              <ng-container *ngIf="!getTicketLevel(ticket, level.id).hidden; else noPrice">
                <div class="price-wrap">
                  <input type="number"
                         class="price-input"
                         [value]="getTicketLevel(ticket, level.id)?.price > 0 ? getTicketLevel(ticket, level.id)?.price : null"
                         (focus)="onLevelPriceFocus(ticket, level.id, $event)"
                         (input)="markDirty('level_' + ticket.id + '_' + level.id); currentLevelEdit[ticket.id + '_' + level.id] = $any($event.target).value"
                         (blur)="saveLevelPrice(ticket, level.id, i, $event)"
                         (keydown)="preventNegative($event)"
                         (keydown.enter)="$any($event.target).blur()"
                         [disabled]="!allowCreate"
                         min="0" step="0.01" placeholder="—" />
                  <span class="price-sym">€</span>
                </div>
              </ng-container>
              <ng-template #noPrice>
                <span class="level-no-price">—</span>
              </ng-template>
            </div>

            <!-- col 5: guardar zona -->
            <div class="level-col-actions">
              <button *ngIf="isDirty('level_' + ticket.id + '_' + level.id)"
                      class="btn-save"
                      type="button"
                      (click)="saveLevelFromButton(ticket, level.id, i)">
                <i class="fal fa-save"></i>
              </button>
              <i class="fal fa-check saved-check"
                 *ngIf="isSaved('level_' + ticket.id + '_' + level.id)"></i>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<!-- Toast switch feedback -->
<div class="save-toast" [class.visible]="toastVisible">
  <i class="fal fa-check"></i>
  <span>{{ toastMsg }}</span>
</div>
